export const useAuth = () => {
    //getting token from local storage

    // Todo: encode token to validate lease
    const user = sessionStorage.getItem('jwt')
    //checking whether token is preset or not
    if (user) {
        return true;
    } else {
        console.log("no authentication token");
        return false
    }
};